export default {"src":"/_next/static/image/public/images/ic_pom_delivery_boy.01259925de3a62a2350386e1498f2fe0.svg","height":24,"width":29};